<template>
  <div class="form-group row">
    <div class="col-11 row">
      <div class="col-sm-2 text-sm-right">
        <label>Número Protocolo:</label>
      </div>
      <div class="col-md-4 col-sm-10 mb-3">
        <the-mask :mask="['##/######/####']" type="text" class="form-control" v-model="filtro.numeroProtocoloFormatado"/>
      </div>

      <div class="col-sm-2 text-sm-right">
        <label>Origem:</label>
      </div>
      <div class="col-md-4 col-sm-10 mb-3">
        <input type="text" class="form-control" v-model="retirado.origem">
      </div>
    </div>

    <div class="col-11 row">
      <div class="col-sm-2 text-sm-right">
        <label>Assunto:</label>
      </div>
      <div class="col-sm-10 mb-3">
        <input type="text" class="form-control" v-model="filtro['assunto.descricao']">
      </div>
    </div>

    <div class="col-11 row">
      <div class="col-sm-2 text-sm-right">
        <label>Interessado:</label>
      </div>
      <div class="col-sm-10 mb-3">
        <input type="text" class="form-control" v-model="filtro['interessados.nome']">
      </div>
    </div>

    <div class="col-12 row btnAcoes">
      <div class="col-1"></div>
      <button class="btn btn-outline-success" @click.prevent="pesquisar()"> Pesquisar </button>
      <button class="btn btn-outline-danger" @click.prevent="limpar()"> Limpar </button>
    </div>
  </div>
</template>

<script>
import eventBus from '@/uteis/eventBus'
import ProcessoElaboracaoService from '@/services/ProcessoElaboracaoService'

export default {
  name: 'filtroPesquisaAReceber',

  props: {
    rowsNumber: { required: true, type: Number },
    eventBusDataName: { required: true, type: String },
    eventBusPaginationName: { required: true, type: String }
  },

  data () {
    return {
      retirado: {
        origem: ''
      },
      filtro: {
        numeroProtocoloFormatado: '',
        'assunto.descricao': '',
        'interessados.nome': '',
        'interessados.rg': '',
        range: this.rowsNumber
      }
    }
  },

  created () {
    eventBus.$on(this.eventBusPaginationName, (numeroPagina) => {
      this.trocaDePagina(numeroPagina)
    })

    this.service = new ProcessoElaboracaoService()
    this.pesquisar()
  },

  methods: {
    pesquisar (page = 1) {
      this.service.buscarProtocoloSPI({
        ...this.filtro,
        offset: page
      }).then(res => {
        eventBus.$emit(this.eventBusDataName, res)
      }).catch(err => {
        console.log(err)
      })
    },

    limpar () {
      this.filtro.numeroProtocoloFormatado = ''
      this.filtro.origem = ''
      this.filtro['assunto.descricao'] = ''
      this.filtro['interessados.nome'] = ''
      this.filtro['interessados.rg'] = ''
      this.pesquisar()
    },

    trocaDePagina (numeroPagina) {
      this.pesquisar(numeroPagina)
    }
  },

  destroyed () {
    eventBus.$off(this.eventBusPaginationName)
  }
}
</script>

<style scoped lang="scss">

.row {
  margin-top: 2px;
}
</style>
